import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Slider from '../Slider';
import SeekBarStyled from './styles/SeekBarStyled';

const SeekBar = ({
  thumbnails,
  duration,
  onChangeHoverTime,
  position,
  loadedFraction,
  play,
  pause,
  paused,
  getSeeking,
  isMobile,
  setSkipAdProperty,
  handleSeeking,
  seek,
}) => {
  const handleChange = (time, phase) => {
    if (
      (!isMobile && phase !== Slider.SLIDE_PHASE.END) ||
      (isMobile && phase === Slider.SLIDE_PHASE.END)
    ) {
      seek(time);
    }
  };

  return (
    <SeekBarStyled>
      <Slider
        thumbnails={thumbnails}
        max={duration}
        onChangeHoverTime={onChangeHoverTime}
        currentTime={position}
        loadedFraction={loadedFraction}
        onChange={handleChange}
        offset={0}
        secondsPrefix="00:00:"
        minutesPrefix="00:"
        useBuffering
        play={play}
        pause={pause}
        paused={paused}
        getSeeking={getSeeking}
        isMobile={isMobile}
        throttlingTime={300}
        threshold={2}
        setSkipAdProperty={setSkipAdProperty}
        handleSeeking={handleSeeking}
      />
    </SeekBarStyled>
  );
};

SeekBar.propTypes = {
  duration: PropTypes.number,
  position: PropTypes.number,
  loadedFraction: PropTypes.number,
  seek: PropTypes.func,
  onChangeHoverTime: PropTypes.func,
  thumbnails: PropTypes.object.isRequired,
  pause: PropTypes.func,
  play: PropTypes.func,
  paused: PropTypes.bool,
  getSeeking: PropTypes.func,
  isMobile: PropTypes.bool,
  setSkipAdProperty: PropTypes.func,
  handleSeeking: PropTypes.func,
};

SeekBar.defaultProps = {
  duration: 0,
  position: 0,
  loadedFraction: 0,
  onChangeHoverTime: Function.prototype,
  seek: Function.prototype,
  play: Function.prototype,
  pause: Function.prototype,
  paused: null,
  getSeeking: Function.prototype,
  isMobile: false,
  setSkipAdProperty: Function.prototype,
  handleSeeking: Function.prototype,
};

export default memo(SeekBar);
